import React, { memo, useCallback } from 'react';
import { Segment } from 'semantic-ui-react';
import { ChevronDownIcon, ChevronUpIcon } from '../Icon';
import { IdentityDetails } from './IdentityDetails';


var IdentityComponent = memo(function (_a) {
    var _b, _c;
    var identity = _a.identity, onIdentityClick = _a.onIdentityClick, isOpen = _a.isOpen, className = _a.className;
    var handleIdentityClick = useCallback(function () {
        onIdentityClick(identity.id);
    }, [identity, onIdentityClick]);
    return (React.createElement(Segment, { className: "Identity pluggy " + (className || '') },
        React.createElement("div", { className: 'row' },
            React.createElement("div", { className: 'column' },
                React.createElement("p", { className: 'column-header' }, "Identidade"),
                React.createElement("p", { className: 'value' }, (_b = identity.fullName) !== null && _b !== void 0 ? _b : '-')),
            React.createElement("div", { className: 'column' },
                React.createElement("p", { className: 'column-header' }, identity.documentType),
                React.createElement("p", { className: 'value' }, (_c = identity.document) !== null && _c !== void 0 ? _c : '-')),
            React.createElement("div", { className: 'column icon-column', onClick: handleIdentityClick }, isOpen ? React.createElement(ChevronUpIcon, null) : React.createElement(ChevronDownIcon, null))),
        isOpen && React.createElement(IdentityDetails, { identity: identity })));
});
export { IdentityComponent };
